import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14 3.086v9.828A1.087 1.087 0 0 1 12.914 14H10.4V9.2h1.547l.233-1.8H10.4v-.92c0-.52.147-.88.874-.88h.913V3.746a12.124 12.124 0 0 0-1.333-.073A2.148 2.148 0 0 0 8.6 6.066V7.4H6.8v1.8h1.8V14H3.086A1.087 1.087 0 0 1 2 12.914V3.086A1.087 1.087 0 0 1 3.086 2h9.828A1.087 1.087 0 0 1 14 3.086Z';
const draw24px = 'M21,4.61V19.35A1.63,1.63,0,0,1,19.37,21H15.6v-7.2h2.32l.35-2.7H15.6V9.7c0-.78.22-1.32,1.31-1.32h1.37V5.6a19,19,0,0,0-2-.11c-2,0-3.38,1.27-3.38,3.59v2H10.2v2.7h2.7V21H4.63A1.63,1.63,0,0,1,3,19.35V4.61A1.63,1.63,0,0,1,4.63,3H19.37A1.63,1.63,0,0,1,21,4.61Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const LogoFacebookIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'logoFacebook'));
LogoFacebookIcon.displayName = 'LogoFacebookIcon';
LogoFacebookIcon.propTypes = Icon.propTypes;
LogoFacebookIcon.renderIcon = props => /*#__PURE__*/React.createElement(LogoFacebookIcon, props);
export default LogoFacebookIcon;
//# sourceMappingURL=LogoFacebookIcon.js.map